module.exports = __webpack_public_path__ + "media/images/herospark_mail_signature-ad1e13516f07e8710a1e97d2b21119a9.svg";